module.exports = __webpack_public_path__ + "./docs/img/big-icon-module.6b6c926048d5c19f878013e8c8552fb8.svg";